import Flowit from '../../../services/flowit';
import * as types from './types';

export const loadList = ({ commit, getters }, params = null) => {
  commit(types.LOAD, true);
  
  // Usar parâmetros fornecidos ou filtros padrão
  const filters = params || getters.chargebacksFilter;
  
  Flowit.chargebacks.loadList(filters)
    .then(response => {
      // Extrair o array chargebacks do objeto de resposta
      let data = [];
      if (response.data && response.data.chargebacks) {
        data = Array.isArray(response.data.chargebacks) ? response.data.chargebacks : [];
      } else if (Array.isArray(response.data)) {
        // Fallback para resposta direta em array
        data = response.data;
      }
      
      commit(types.LIST, data);
      commit(types.LOAD, false);
    })
    .catch(error => {
      commit(types.LOAD, false);
      
      // Melhor tratamento de erro para tokens expirados
      if (!error.response) {
        // Erro de rede ou token expirado
        commit(types.ERROR_STATUS, true);
        commit(types.ERROR_MESSAGE, 'Erro de conexão. Verifique sua sessão.');
        return;
      }
      
      if (error.response.status === 401) {
        // Token expirado - deixar o interceptor do client.js lidar
        commit(types.ERROR_STATUS, true);
        commit(types.ERROR_MESSAGE, 'Sessão expirada. Redirecionando...');
        return;
      }
      
      // Outros erros
      const errorMessage = (error.response.data && error.response.data.message) || 'Erro ao carregar dados';
      commit(types.ERROR_STATUS, true);
      commit(types.ERROR_MESSAGE, errorMessage);
    });
};

export const sendReceipt = ({ commit }, params) => {
  commit(types.LOAD, true);
  Flowit.chargebacks.sendReceipt(params)
    .then(response => {
      commit(types.LOAD, false);
      commit(types.SUCCESS_STATUS, true);
      commit(types.ERROR_MESSAGE, 'Recibo enviado com sucesso!');
    })
    .catch(error => {
      commit(types.LOAD, false);
      
      // Melhor tratamento de erro para tokens expirados
      if (!error.response) {
        commit(types.ERROR_STATUS, true);
        commit(types.ERROR_MESSAGE, 'Erro de conexão. Verifique sua sessão.');
        return;
      }
      
      if (error.response.status === 401) {
        commit(types.ERROR_STATUS, true);
        commit(types.ERROR_MESSAGE, 'Sessão expirada. Redirecionando...');
        return;
      }
      
      // Outros erros
      const errorMessage = (error.response.data && error.response.data.message) || 'Erro ao enviar recibo';
      commit(types.ERROR_STATUS, true);
      commit(types.ERROR_MESSAGE, errorMessage);
    });
};

// Actions para filtros
export const setInitialDate = ({ commit }, date) => {
  commit(types.FILTERS_INITIAL_DATE, date);
};

export const setFinalDate = ({ commit }, date) => {
  commit(types.FILTERS_FINAL_DATE, date);
};

export const setStatus = ({ commit }, status) => {
  commit(types.FILTERS_STATUS, status);
};

export const setReason = ({ commit }, reason) => {
  commit(types.FILTERS_REASON, reason);
};

export const setAmount = ({ commit }, amount) => {
  commit(types.FILTERS_AMOUNT, amount);
};

export const setOrdination = ({ commit }, ordination) => {
  commit(types.FILTERS_ORDINATION, ordination);
};

export const showFilters = ({ commit }, show) => {
  commit(types.SHOW_FILTERS, show);
};

export const resetFilters = ({ commit, dispatch }) => {
  commit(types.FILTERS_INITIAL_DATE, '');
  commit(types.FILTERS_FINAL_DATE, '');
  commit(types.FILTERS_STATUS, '');
  commit(types.FILTERS_REASON, '');
  commit(types.FILTERS_AMOUNT, '');
  commit(types.FILTERS_ORDINATION, '');
  dispatch('loadList');
};
